import React from 'react';
import CelebLayout from '../views/celebtracker/CelebLayout';
import Contact from '../views/celebtracker/Contact';
import CookieStorage from '../views/celebtracker/CookieStorage';
import CreatorPreview from '../views/celebtracker/CreatorPreview';
import Discover from '../views/celebtracker/Discover';
import EventDetail from '../views/celebtracker/EventDetail';
import Feed from '../views/celebtracker/Feed';
import FindClothesByPicture from '../views/celebtracker/FindClothesByPicture';
import FollowedProfile from '../views/celebtracker/FollowedProfile';
import HowItWorks from '../views/celebtracker/HowItWorks';
import Legal from '../views/celebtracker/Legal';
import MediaLibrary from '../views/celebtracker/MediaLibrary';
import NotFound from '../views/celebtracker/NotFound';
import Privacy from '../views/celebtracker/Privacy';
import Profile from '../views/celebtracker/Profile';
import PublicTryOn from '../views/celebtracker/PublicTryOn';
import PublicLookPage from '../views/celebtracker/PublicLookPage';
import PublicStylePage from '../views/celebtracker/PublicStylePage';
import RequireAuth from '../views/celebtracker/RequireAuth';
import SavedLooks from '../views/celebtracker/SavedLooks';
import SeoToolPage from '../views/celebtracker/SeoToolPage';
import Terms from '../views/celebtracker/Terms';
import TryOnFeed from '../views/celebtracker/TryOnFeed';
import '../views/celebtracker/styles.css';

export const IndexRouters = [
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/legal',
    element: <Legal />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/cookies',
    element: <CookieStorage />,
  },
  {
    path: '/',
    element: <CelebLayout />,
    children: [
      {
        path: '/',
        element: <Feed />,
      },
      {
        path: '/discover',
        element: <RequireAuth titleKey="authPrompt.followTitle" copyKey="authPrompt.followCopy"><Discover /></RequireAuth>,
      },
      {
        path: '/events/:id',
        element: <EventDetail />,
      },
      {
        path: '/photos',
        element: <RequireAuth titleKey="authPrompt.photosTitle" copyKey="authPrompt.photosCopy"><MediaLibrary /></RequireAuth>,
      },
      {
        path: '/fit-wall',
        element: <TryOnFeed />,
      },
      {
        path: '/how-it-works',
        element: <HowItWorks />,
      },
      {
        path: '/find-clothes-by-picture',
        element: <FindClothesByPicture />,
      },
      {
        path: '/ai-outfit-finder',
        element: <SeoToolPage pageKey="/ai-outfit-finder" />,
      },
      {
        path: '/find-similar-clothes',
        element: <SeoToolPage pageKey="/find-similar-clothes" />,
      },
      {
        path: '/t/:shareId',
        element: <PublicTryOn />,
      },
      {
        path: '/creator-preview/:token',
        element: <CreatorPreview />,
      },
      {
        path: '/style/:slug',
        element: <PublicStylePage />,
      },
      {
        path: '/looks/:id',
        element: <PublicLookPage />,
      },
      {
        path: '/saved',
        element: <RequireAuth titleKey="authPrompt.savedTitle" copyKey="authPrompt.savedCopy"><SavedLooks /></RequireAuth>,
      },
      {
        path: '/profile',
        element: <RequireAuth><Profile /></RequireAuth>,
      },
      {
        path: '/following/:slug',
        element: <RequireAuth titleKey="authPrompt.followTitle" copyKey="authPrompt.followCopy"><FollowedProfile /></RequireAuth>,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
